export function useTOC(
   initialState: any = {
      data: {},
   }
) {
   // HELPERS ========================
   type Section = {
      title?: string | null;
      id?: string | null;
      anchors: { label: string; id: string }[];
   };
   // STATE ========================
   const toc = useState<Record<string, Section>>("toc", () => ({}));

   const buildTOC = (type: string, el: HTMLElement) => {
      // Build Sections
      toc.value = {};
      const buildSections = (
         elements: HTMLElement[],
         sectionIndex: number = 0
      ) => {
         const sectionKey = `${type}_${sectionIndex + 1}`;

         // Initialize the section within the TOC state.
         toc.value[sectionKey] = {
            anchors: [],
         } as Section;

         elements.forEach((element, index) => {
            if (!element) {
               throw Error("Missing TOC");
            }
            const anchorId = `anchor-${sectionKey}-heading-${index}`;
            element?.setAttribute("id", anchorId);

            if (index === 0) {
               // Set title and primary id for the section.
               toc.value[sectionKey].title = element.innerText.toLowerCase();
               toc.value[sectionKey].id = anchorId;
            } else {
               // Append subsequent headings as anchors.
               toc.value[sectionKey].anchors.push({
                  label: element.innerText.toLowerCase(),
                  id: anchorId,
               });
            }
         });
      };

      const sortSections = (elements: HTMLElement[]) => {
         // Find indexes of all H2 elements
         const h2Indexes = elements.reduce<number[]>((indexes, el, idx) => {
            if (el.nodeName === "H2") {
               indexes.push(idx);
            }
            return indexes;
         }, []);

         if (h2Indexes.length) {
            // Partition elements into sections using H2 indexes
            h2Indexes.forEach((startIndex, sectionIndex) => {
               const endIndex = h2Indexes[sectionIndex + 1];
               const sectionElements = endIndex
                  ? elements.slice(startIndex, endIndex)
                  : elements.slice(startIndex);
               buildSections(sectionElements, sectionIndex);
            });
         } else {
            // No H2 markers -- use all elements as one section
            buildSections(elements);
         }
      };
      // Gather all h2s and h3s from target el
      const headlineEls = Array.from(
         el.querySelectorAll<HTMLElement>("h2, h3"),
      );
      // If headlines are found, sort sections
      headlineEls?.length && sortSections(headlineEls);
   };

   const activeTOC = computed(() => {
      return toc.value;
   });

   // Reset value on Path Change
   const route = useRoute();
   watch(
      () => route.path,
      (val, oldVal) => {
         val !== oldVal && (toc.value = {});
      }
   );
   return {
      toc: activeTOC,
      buildTOC,
   };
}
